import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./newsletter-form.css";

const contactInfo = [
  {
    icon: "fa-envelope",
    label: "info@infotraceanalytics.com",
    href: "mailto:info@infotraceanalytics.com",
  },
  {
    icon: "fa-phone",
    label: "+254 797 435 680",
    href: "tel:+254797435680",
  },
  {
    icon: "fa-map-marker",
    label: "69825 Mombasa Road, Red Commercial Complex",
    href: "https://maps.app.goo.gl/oi9FKQCUXD4Whxjp9",
  },
];

const navColumns = [
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about-us" },
      { label: "Solutions", to: "/services" },
      { label: "Contact", to: "/contact-us" },
      { label: "Careers", to: "/contact-us#careers" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/blogs" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact Us", to: "/contact-us" },
    ],
  },
];

const socialLinks = [
  {
    icon: "fa-facebook",
    label: "Facebook",
    href: "https://www.facebook.com/InfotraceAnalytics/",
  },
  { icon: "fa-instagram", label: "Instagram", href: "https://www.instagram.com/infotraceanalytics/" },
  { icon: "fa-youtube-play", label: "YouTube", href: "https://www.youtube.com/@infotracemedia5593" },
];

function Footer() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const currentYear = new Date().getFullYear();

  const handleSubscription = async (e) => {
    e.preventDefault();

    // Helper to show status and hide after 5 seconds
    const showStatus = (type, message) => {
      setSubscriptionStatus({ type, message });
      setTimeout(() => setSubscriptionStatus(null), 5000);
    };

    // Basic email validation
    if (!email || !email.includes("@")) {
      showStatus("error", "Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    setSubscriptionStatus(null);

    try {
      const response = await fetch("https://mailer.infotraceanalytics.com/newsletterSubscribe.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (result.success) {
        showStatus("success", "Successfully subscribed to our newsletter!");
        setEmail(""); // Clear the input
      } else {
        showStatus("error", result.message || "Subscription failed. Please try again.");
      }
    } catch (error) {
      showStatus("error", "Network error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="tea-footer">
      <div className="tea-footer__container">
        <div className="tea-footer__grid">
          <div className="tea-footer__intro">
            <p className="tea-footer__eyebrow">Powering Smarter Business Insights</p>
            <h3 className="tea-footer__headline">Data That Drives Decisions.</h3>

            <div className="tea-footer__contacts">
              {contactInfo.map((item) => {
                const externalProps = item.href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {};
                return (
                  <a key={item.label} href={item.href} className="tea-footer__contact-link" {...externalProps}>
                    <span className="tea-footer__contact-icon">
                      <i className={`fa ${item.icon}`} aria-hidden="true" />
                    </span>
                    {item.label}
                  </a>
                );
              })}
            </div>
          </div>

          <div className="tea-footer__nav">
            {navColumns.map((column) => (
              <div className="tea-footer__nav-column" key={column.title}>
                <p className="tea-footer__nav-title">{column.title}</p>
                <ul>
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <NavLink to={link.to}>{link.label}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="tea-footer__nav-column">
              <p className="tea-footer__nav-title">Follow Us</p>
              <div className="tea-footer__socials">
                {socialLinks.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    aria-label={item.label}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className={`fa ${item.icon}`} aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="tea-footer__form-col">
            <p className="tea-footer__form-title">Subscribe to our newsletter!</p>
            <form onSubmit={handleSubscription} className="tea-footer__form">
              <div className="tea-footer__input-wrapper">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  required
                />
                <button type="submit" disabled={isSubmitting || !email}>
                  {isSubmitting ? "Sending..." : "Subscribe"}
                </button>
              </div>

              {subscriptionStatus && (
                <p className={`tea-footer__status tea-footer__status--${subscriptionStatus.type}`}>
                  {subscriptionStatus.message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="tea-footer__divider" />

        <div className="tea-footer__bottom">
          <p>© {currentYear} Infotrace Analytics. All rights reserved.</p>
          <div className="tea-footer__bottom-links">
            <NavLink to="/privacy-policy">Privacy</NavLink>
            <NavLink to="/terms">Terms & condition</NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
